import { json } from 'overmind';
export function handleBadges(company, types) {
    if (company.badges === null)
        return false;
    return !!json(company.badges.available_data).find(item => types.includes(item));
}
export function activeCompany(company) {
    return (handleBadges(company, ['active_company']) ||
        company.ds_situacao_cnpj == 'ATIVA');
}
